<script setup lang="ts">
    import type { HTMLAttributes } from 'vue';
    import { cn } from '../../utils';

    const props = defineProps<{ class?: HTMLAttributes['class'] }>();
</script>

<template>
    <div
        data-slot="dialog-footer"
        :class="cn('relative flex flex-col-reverse gap-2 sm:flex-row sm:justify-end py-4 mt-[24px]', props.class)"
    >
        <slot />
    </div>
</template>

<style lang="css" scoped>
    [data-slot='dialog-footer']::before {
        content: '';
        display: block;
        position: absolute;
        border-top: 1px solid var(--color-border-subdued);
        left: -24px;
        right: -24px;
        top: 0px;
    }
</style>
